import { IDeleteMultipleBaseRequest } from "../../../models/request/base/deleteRequest"
import { nt_diem_danh_trang_thai } from "../../../models/response/category/nt_diem_danh_trang_thai"

export enum eDiemDanhTrangThaiActionTypeIds {
    LOAD_START = "DIEMDANH_TRANGTHAI_LOAD_START",
    LOAD_SUCCESS = "DIEMDANH_TRANGTHAI_LOAD_SUCCESS",
    LOAD_ERROR = "DIEMDANH_TRANGTHAI_LOAD_ERROR",

    SHOW_DETAIL = "DIEMDANH_TRANGTHAI_SHOW_DETAIL",
    CLOSE_DETAIL = "DIEMDANH_TRANGTHAI_CLOSE_DETAIL",

    CHANGE_SELECTED_IDS = "DIEMDANH_TRANGTHAI_CHANGE_SELECTED_IDS",

    SHOW_CONFIRM = "DIEMDANH_TRANGTHAI_SHOW_CONFIRM",
    CLOSE_CONFIRM = "DIEMDANH_TRANGTHAI_CLOSE_CONFIRM",

    DELETE_START = "DIEMDANH_TRANGTHAI_DELETE_START",
    DELETE_SUCCESS = "DIEMDANH_TRANGTHAI_DELETE_SUCCESS",
    DELETE_ERROR = "DIEMDANH_TRANGTHAI_DELETE_ERROR",

    SAVE_START = "DIEMDANH_TRANGTHAI_SAVE_START",
    SAVE_SUCCESS = "DIEMDANH_TRANGTHAI_SAVE_SUCCESS",
    SAVE_ERR = "DIEMDANH_TRANGTHAI_SAVE_ERR"
}

export interface IDiemDanhTrangThaiLoadStart {
    type: eDiemDanhTrangThaiActionTypeIds.LOAD_START,
}
export interface IDiemDanhTrangThaiLoadSuccess {
    type: eDiemDanhTrangThaiActionTypeIds.LOAD_SUCCESS,
    payload: nt_diem_danh_trang_thai[]
}
export interface IDiemDanhTrangThaiLoadErr {
    type: eDiemDanhTrangThaiActionTypeIds.LOAD_ERROR,
    payload: string
}
export interface IDiemDanhTrangThaiShowDetail {
    type: eDiemDanhTrangThaiActionTypeIds.SHOW_DETAIL,
    payload?: nt_diem_danh_trang_thai
}
export interface IDiemDanhTrangThaiCloseDetail {
    type: eDiemDanhTrangThaiActionTypeIds.CLOSE_DETAIL,
}
export interface IDiemDanhTrangThaiChangeSelectedIds {
    type: eDiemDanhTrangThaiActionTypeIds.CHANGE_SELECTED_IDS,
    payload: number[]
}
export interface IDiemDanhTrangThaiShowConfirm {
    type: eDiemDanhTrangThaiActionTypeIds.SHOW_CONFIRM
}
export interface IDiemDanhTrangThaiCloseConfirm {
    type: eDiemDanhTrangThaiActionTypeIds.CLOSE_CONFIRM
}

export interface IDiemDanhTrangThaiDeleteStart {
    type: eDiemDanhTrangThaiActionTypeIds.DELETE_START,
    payload: IDeleteMultipleBaseRequest
}
export interface IDiemDanhTrangThaiDeleteSuccess {
    type: eDiemDanhTrangThaiActionTypeIds.DELETE_SUCCESS,
}
export interface IDiemDanhTrangThaiDeleteErr {
    type: eDiemDanhTrangThaiActionTypeIds.DELETE_ERROR,
    payload: string
}
export interface IDiemDanhTrangThaiSaveStart {
    type: eDiemDanhTrangThaiActionTypeIds.SAVE_START,
    payload: nt_diem_danh_trang_thai
}
export interface IDiemDanhTrangThaiSaveSuccess {
    type: eDiemDanhTrangThaiActionTypeIds.SAVE_SUCCESS
}
export interface IDiemDanhTrangThaiSaveErr {
    type: eDiemDanhTrangThaiActionTypeIds.SAVE_ERR,
    payload: string
}
export type IDiemDanhTrangThaiActionTypes = IDiemDanhTrangThaiLoadStart | IDiemDanhTrangThaiLoadSuccess | IDiemDanhTrangThaiLoadErr |
    IDiemDanhTrangThaiShowDetail | IDiemDanhTrangThaiCloseDetail |
    IDiemDanhTrangThaiChangeSelectedIds |
    IDiemDanhTrangThaiShowConfirm | IDiemDanhTrangThaiCloseConfirm |
    IDiemDanhTrangThaiDeleteStart | IDiemDanhTrangThaiDeleteSuccess | IDiemDanhTrangThaiDeleteErr |
    IDiemDanhTrangThaiSaveStart | IDiemDanhTrangThaiSaveSuccess | IDiemDanhTrangThaiSaveErr